import {
  isHoneycomb,
  TILE_CONTENT,
  TILE_SIZES,
} from '@mixtiles/web-backend-shared'
import {
  calculateAllPossibleRatios,
  fitCropToAllRatios,
} from '../../utils/cropRatioUtils'
import { isAllowedArtwork } from '../../services/artCatalogService'

// Set tileContent for tiles without it
export function migrateTileContent(tile) {
  if (!tile.tileContent) {
    tile.tileContent = tile.isCenterpiece
      ? TILE_CONTENT.CENTERPIECE
      : tile.artwork
      ? TILE_CONTENT.ART_PHOTO
      : TILE_CONTENT.PHOTO
  }
  return tile
}

export function migrateHoneycombTiles(tile) {
  if (isHoneycomb(tile.tileSize)) {
    return {
      ...tile,
      tileSize: TILE_SIZES.SQUARE_8X8,
    }
  }
  return tile
}

export function migrateCropParams(tile) {
  let { cropParams } = tile
  const allAspectRatios = calculateAllPossibleRatios()
  if (!cropParams || Object.keys(cropParams).length === 0) {
    // A simple migration from crop by tile size to crop by tile aspect ratio
    cropParams = {}
  } else {
    const missingAspectRatios = allAspectRatios.filter(
      (aspectRatio) => !(aspectRatio in cropParams)
    )
    if (missingAspectRatios.length > 0) {
      // If some cropParams do not exist - calculate based on existing ones. For example when restoring from OrderDraft,
      // because cropParams are Record<number, Crop>, and mongo doesn't save the cropParams that contains "."
      const existingAspectRatio =
        tile.currentAspectRatio in cropParams
          ? tile.currentAspectRatio
          : Object.keys(cropParams)[0]
      cropParams = {
        ...fitCropToAllRatios({
          ratiosToCalculate: missingAspectRatios,
          cropRect: cropParams[existingAspectRatio],
          currentAspectRatio: Number(existingAspectRatio),
          imageWidth: tile.width,
          imageHeight: tile.height,
        }),
        ...cropParams,
      }
    }
  }

  return { ...tile, cropParams }
}

// Filter out art tiles from non-allowed artists (old catalog)
export function filterOldArtTiles(tiles) {
  return tiles.filter((tile) => {
    if (!tile.artwork) return true
    return isAllowedArtwork(tile.artwork)
  })
}
